// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"20025":"03b6159bf7a8d49b","64228":"057ed29165f6b05b","66404":"a2fc9830d4c051a8"}[chunkId] + ".css";
};